import React from "react";
import { Button, Spinner } from "flowbite-react";

const ReviewStep = ({ formData, prevStep, submitForm, createLoading }) => {
  const students = formData.students || [];
  const clusterName = formData.clusterName;

  return (
    <div className="flex flex-col flex-1 min-h-0 w-full h-full pt-0.5">
      <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain pe-1 space-y-4">
        {/* Students Section */}
        <div className="border rounded-lg p-3 shadow-sm bg-white hover:bg-gray-50 transition">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-base font-semibold text-gray-700">
              List of Mail IDs
            </h3>
            <span className="text-sm font-semibold text-gray-600">
              Count : {students.length}
            </span>
          </div>
          <ul className="max-h-40 overflow-y-auto text-sm text-gray-600 space-y-1">
            {students.length > 0 ? (
              students.map((student, index) => (
                <li
                  key={index}
                  className="px-2 py-1 rounded-md hover:bg-gray-100 cursor-default"
                >
                  {student.email}
                </li>
              ))
            ) : (
              <li className="text-gray-500 text-sm">No students added</li>
            )}
          </ul>
        </div>

        {/* Cluster Section */}
        <div className="border rounded-lg p-3 shadow-sm bg-white hover:bg-gray-50 transition">
          <h3 className="text-base font-semibold text-gray-700">Cluster:</h3>
          <p className="text-sm text-gray-600 mt-1">{clusterName || "N/A"}</p>
        </div>
      </div>

      <div className="flex justify-between w-full gap-2 shrink-0 pt-4 border-t border-gray-100">
        <Button size="sm" className="bg-primary px-3 font-semibold shrink-0" onClick={prevStep}>
          Prev
        </Button>
        <Button
          size="sm"
          className="flex items-center justify-center px-3 font-semibold shrink-0 bg-primary enabled:hover:opacity-90"
          onClick={submitForm}
          disabled={createLoading}
        >
          {createLoading ? <Spinner /> : "Submit"}
        </Button>
      </div>
    </div>
  );
};

export default ReviewStep;
